module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnumber"
  }, [_c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_vm._v("Chapter 1")])]), _c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("The Oldest Parish Churches")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("s a general rule, the oldest building in a village is the parish church. Indeed, some South Yorkshire churches have architecture or sculpture that is more than a thousand years old. In many of our ancient villages the parish church was even more dominant in the Middle Ages than it is today, for it was usually the only building that was constructed of stone. But, as with many rules, there are exceptions. Today’s villages may once have been just small places within large parishes whose church stood a few miles away. In other cases the medieval church has been rebuilt so thoroughly that nothing of the earlier work survives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The oldest surviving building in South Yorkshire is St Peter’s church, Conisbrough, the great minster church that served the royal estate of the kingdom of Northumbria near its southern boundary. Conisbrough means ‘the king’s stronghold’. Its territory stretched as far south as Harthill on the county boundary and as far east as the lowland moors beyond Thorne. The church is much older than the Norman castle across the valley, but as it was extended and enlarged from the twelfth century onwards the ancient part is now hidden from external view. On entering the building through the south door, however, we can see immediately that the outer walls of the nave have large corner stones (quoins) laid in the ‘side-alternate’ manner that was typical of the Northumbrian method of building. The lofty, rather narrow proportions of the nave are also typical of this early style.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_vm._v("The Normans enlarged the original church by constructing arches in the walls and by creating aisles. The remains of three pre-Conquest windows and a narrow, blocked opening that Peter Ryder suggested led into a side-chapel known as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("porticus")]), _vm._v(" can be detected above the arches."), _c('sup')]), _c('a', {
    attrs: {
      "id": "fn1-1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" The lower part of the west tower also dates from before the Norman Conquest. Although we do not know exactly how old the original church is, it was certainly built during the Anglo-Scandinavian era, that long period when the Angles and the Vikings were dominant in the North.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dbaf46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_chapter01.vue
// module id = 72
// module chunks = 0